import { render, staticRenderFns } from "./ShowEditMain.vue?vue&type=template&id=013a8693&lang=pug&"
import script from "./ShowEditMain.vue?vue&type=script&lang=js&"
export * from "./ShowEditMain.vue?vue&type=script&lang=js&"
import style0 from "./ShowEditMain.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "ShowEditMain.vue"
export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTab } from 'vuetify/lib'
import { VTabItem } from 'vuetify/lib'
import { VTabs } from 'vuetify/lib'
installComponents(component, {
  VTab,
  VTabItem,
  VTabs,
})
